<div class="page font-family bodyBackground">
  @if (isProfileContentReady && isRequireInfoReady) {
    <div class="header-navigation-back">
      <span>Welcome {{ driverName }}!</span>
    </div>
  }
  @if (!(isProfileContentReady && isRequireInfoReady)) {
    <app-loading-gif></app-loading-gif>
  }
  @if (isProfileContentReady && isRequireInfoReady) {
    <div class="content">
      <div class="profile-card">
        <div class="profile-image-wrapper">
          <img [src]="profilePicturePath" alt="Profile Picture" class="profile-image" />
        </div>
        <div class="profile-details">
          <div class="driver-name">{{ driverFullName }}</div>
          <div class="driver-email">{{ driverEmail }}</div>
          <div class="driver-id">{{ driverId | uppercase }}</div>
        </div>
      </div>
      <mat-divider></mat-divider>

      <!-- Temporarily hidden: dashboard shortcuts to order PCC and abstracts.
      <div class="order-cards-compact">
        <div class="compact-card pcc-compact" (click)="orderPcc()">
          <div class="compact-card-content">
            <div class="compact-title">Order Criminal Record (Background) Check</div>
            <div class="compact-subtitle">Online. Delivered in minutes.</div>
          </div>
        </div>
        <div
          class="compact-card abstract-compact"
          (click)="onAbstractTileClick()"
          [attr.data-test]="environment?.featureFlags?.enableAbstractTelematicsBundle ? 'order-abstracts-telematics' : 'order-abstracts'">
          <div class="compact-card-content">
            @if (environment?.featureFlags?.enableAbstractTelematicsBundle) {
              <div class="compact-title">Order Abstracts, Telematics</div>
              <div class="compact-subtitle">Driving record &amp; behavior insights.</div>
            } @else {
              <div class="compact-title">Order Abstracts</div>
              <div class="compact-subtitle">Online. Available for Ontario.</div>
            }
          </div>
        </div>
      </div>
      -->

    <!-- Driver Risk Profile -->
    @if (environment?.featureFlags?.enableDriverRiskProfile) {
      <div class="profile-progress-card margin-left-sm margin-top-sm" (click)="navigateToRiskProfile()">
        <div class="icon-div">
          <mat-icon class="mat-icon">insights</mat-icon>
        </div>
        <div class="profile-content">
          <div class="title">Risk Profile</div>
          <div class="subtitle">View mileage & safety analytics</div>
        </div>
      </div>
    }

    <div class="profile-progress-card margin-left-sm margin-top-sm" (click)="onNavigateToProfile()">
      <div>
        <app-modern-circular-progress
          [value]="showPercentage"
          [size]="60"
          [color]="showPercentage > 99 ? '#48bb78' : (showPercentage > 0 ? '#756ef3' : '#dfdfdf')"
          [backgroundColor]="'#a0a0a0'"
          [strokeWidth]="4">
        </app-modern-circular-progress>
      </div>
      <div class="profile-content">
        <div class="title">Your Digital Profile</div>
        <div class="subtitle">Manage your Digital Driver Profile</div>
      </div>
    </div>

    <div class="profile-progress-card margin-left-sm margin-top-sm" (click)="navigateToMyDocuments()">
      <div class="icon-div">
        <mat-icon class="mat-icon" svgIcon="my-documents"></mat-icon>
      </div>
      <div class="profile-content">
        <div class="title">My Documents</div>
        <div class="subtitle">
          <span>Manage all your professional </span><span>documents including Trainings </span
          ><span>& Certificates</span>
        </div>
      </div>
    </div>

    <!-- Job Board: shown for drivers without active carrier employment -->
    @if (showJobBoardCard) {
      <div class="profile-progress-card job-board-card margin-left-sm margin-top-sm" (click)="navigateToJobBoard()" data-test="job-board-card">
        <div class="icon-div">
          <mat-icon class="mat-icon">work_outline</mat-icon>
        </div>
        <div class="profile-content">
          <div class="title">Open Driver Jobs</div>
          <div class="subtitle">{{ jobBoardCountryLabel }} · Browse and apply</div>
        </div>
      </div>
    }

    <!-- Driver Qualification Files Section -->
    @if (carrierAssociationCards && carrierAssociationCards.length > 0) {
      @for (carrier of carrierAssociationCards; track carrier.carrierCompanyId) {
        <div class="profile-progress-card margin-left-sm margin-top-sm dqf-card" 
          [class.disabled]="isWithdrawn(carrier.dqfStatus)"
          (click)="!isWithdrawn(carrier.dqfStatus) && onCarrierCardClick(carrier)" 
          data-test="dqf-section"
          [attr.data-id]="carrier.carrierCompanyName"
          [attr.data-testid]="'dqf-card-' + (carrier.carrierCompanyName | lowercase)">
          <div class="dqf-content">
            <!-- For Hired Drivers (Active) - Always show as Active regardless of DQF status -->
            @if (isHired(carrier.hiredStatus)) {
              <div class="dqf-approved-hired">
                @if (getCardStatusDateLine(carrier); as dateLine) {
                  <div class="card-status-date-line" data-test="card-status-date" [attr.data-testid]="'dqf-status-date-' + (carrier.carrierCompanyName | lowercase)">{{ dateLine }}</div>
                }
                <div class="carrier-logo-large">
                  <img
                    [src]="carrier.carrierCompanyLogo || 'assets/images/company-placeholder.png'"
                    [alt]="carrier.carrierCompanyName + ' logo'"
                    class="carrier-logo-img-large">
                </div>
                <div class="carrier-main-row">
                  <div class="carrier-names">
                    <span class="carrier-name-large" [attr.data-testid]="'dqf-carrier-name-' + (carrier.carrierCompanyName | lowercase)">{{ carrier.carrierCompanyName | uppercase }}</span>
                    @if (shouldShowDbaName(carrier)) {
                      <span class="carrier-dba-name">{{ carrier.carrierDbaName }}</span>
                    }
                  </div>
                  <div class="active-status-badge" [attr.data-testid]="'dqf-status-' + (carrier.carrierCompanyName | lowercase)">
                    <span class="status-dot"></span>
                    <span class="status-text">Active</span>
                  </div>
                </div>
                @if (getCardStatusDescription(carrier); as statusDescription) {
                  <div class="carrier-status-description" [attr.data-testid]="'dqf-status-description-' + (carrier.carrierCompanyName | lowercase)">{{ statusDescription }}</div>
                }
              </div>
            }
            
            <!-- For Non-Hired Drivers with DQF -->
            @if (!isHired(carrier.hiredStatus) && carrier.hasDqf) {
              <!-- Incomplete and Pending - Centered button layout like Active -->
              @if (isInComplete(carrier.dqfStatus) || isPending(carrier.dqfStatus)) {
                @if (isInComplete(carrier.dqfStatus)) {
                  <div class="dqf-with-new-badge">
                    <span class="new-badge-top-center" [attr.data-testid]="'dqf-new-badge-' + (carrier.carrierCompanyName | lowercase)">New</span>
                    <div class="dqf-approved-hired">
                      @if (getCardStatusDateLine(carrier); as dateLine) {
                        <div class="card-status-date-line" data-test="card-status-date" [attr.data-testid]="'dqf-status-date-' + (carrier.carrierCompanyName | lowercase)">{{ dateLine }}</div>
                      }
                      <div class="carrier-logo-large">
                        <img
                          [src]="carrier.carrierCompanyLogo || 'assets/images/company-placeholder.png'"
                          [alt]="carrier.carrierCompanyName + ' logo'"
                          class="carrier-logo-img-large">
                      </div>
                      <div class="carrier-main-row">
                        <div class="carrier-names">
                          <span class="carrier-name-large" [attr.data-testid]="'dqf-carrier-name-' + (carrier.carrierCompanyName | lowercase)">{{ carrier.carrierCompanyName | uppercase }}</span>
                          @if (shouldShowDbaName(carrier)) {
                            <span class="carrier-dba-name">{{ carrier.carrierDbaName }}</span>
                          }
                        </div>
                        <button mat-flat-button color="primary" class="dqf-action-btn-centered" [attr.data-testid]="'dqf-submit-' + (carrier.carrierCompanyName | lowercase)">
                          Submit DQF
                        </button>
                      </div>
                      @if (getCardStatusDescription(carrier); as statusDescription) {
                        <div class="carrier-status-description" [attr.data-testid]="'dqf-status-description-' + (carrier.carrierCompanyName | lowercase)">{{ statusDescription }}</div>
                      }
                    </div>
                  </div>
                }
                @if (isPending(carrier.dqfStatus)) {
                  <div class="dqf-approved-hired">
                    @if (getCardStatusDateLine(carrier); as dateLine) {
                      <div class="card-status-date-line" data-test="card-status-date" [attr.data-testid]="'dqf-status-date-' + (carrier.carrierCompanyName | lowercase)">{{ dateLine }}</div>
                    }
                    <div class="carrier-logo-large">
                      <img
                        [src]="carrier.carrierCompanyLogo || 'assets/images/company-placeholder.png'"
                        [alt]="carrier.carrierCompanyName + ' logo'"
                        class="carrier-logo-img-large">
                    </div>
                    <div class="carrier-main-row">
                      <div class="carrier-names">
                        <span class="carrier-name-large" [attr.data-testid]="'dqf-carrier-name-' + (carrier.carrierCompanyName | lowercase)">{{ carrier.carrierCompanyName | uppercase }}</span>
                        @if (shouldShowDbaName(carrier)) {
                          <span class="carrier-dba-name">{{ carrier.carrierDbaName }}</span>
                        }
                      </div>
                      <div class="status-badge under-review" [attr.data-testid]="'dqf-status-' + (carrier.carrierCompanyName | lowercase)">
                        <span class="status-text">Under Review</span>
                      </div>
                    </div>
                    @if (getCardStatusDescription(carrier); as statusDescription) {
                      <div class="carrier-status-description" [attr.data-testid]="'dqf-status-description-' + (carrier.carrierCompanyName | lowercase)">{{ statusDescription }}</div>
                    }
                  </div>
                }
              }
              
              <!-- Approved but not hired -->
              @if (isApproved(carrier.dqfStatus)) {
                <div class="dqf-approved-hired">
                  @if (getCardStatusDateLine(carrier); as dateLine) {
                    <div class="card-status-date-line" data-test="card-status-date" [attr.data-testid]="'dqf-status-date-' + (carrier.carrierCompanyName | lowercase)">{{ dateLine }}</div>
                  }
                  <div class="carrier-logo-large">
                    <img
                      [src]="carrier.carrierCompanyLogo || 'assets/images/company-placeholder.png'"
                      [alt]="carrier.carrierCompanyName + ' logo'"
                      class="carrier-logo-img-large">
                  </div>
                  <div class="carrier-main-row">
                    <div class="carrier-names">
                      <span class="carrier-name-large" [attr.data-testid]="'dqf-carrier-name-' + (carrier.carrierCompanyName | lowercase)">{{ carrier.carrierCompanyName | uppercase }}</span>
                      @if (shouldShowDbaName(carrier)) {
                        <span class="carrier-dba-name">{{ carrier.carrierDbaName }}</span>
                      }
                    </div>
                    <div class="active-status-badge approved-badge" [attr.data-testid]="'dqf-status-' + (carrier.carrierCompanyName | lowercase)">
                      <mat-icon class="status-icon">check_circle</mat-icon>
                      <span class="status-text">Approved</span>
                    </div>
                  </div>
                  @if (getCardStatusDescription(carrier); as statusDescription) {
                    <div class="carrier-status-description" [attr.data-testid]="'dqf-status-description-' + (carrier.carrierCompanyName | lowercase)">{{ statusDescription }}</div>
                  }
                </div>
              }
              
              <!-- Rejected and Withdrawn - Keep header row layout -->
              @if (isRejected(carrier.dqfStatus) || isWithdrawn(carrier.dqfStatus)) {
                <div class="dqf-header-row">
                  <div class="dqf-title">
                    @if (isRejected(carrier.dqfStatus)) {
                      <span [attr.data-testid]="'dqf-status-' + (carrier.carrierCompanyName | lowercase)">DQF Update Required</span>
                    }
                    @if (isWithdrawn(carrier.dqfStatus)) {
                      <span [attr.data-testid]="'dqf-status-' + (carrier.carrierCompanyName | lowercase)">DQF Withdrawn</span>
                    }
                  </div>
                  <div class="dqf-button-wrapper">
                    @if (isRejected(carrier.dqfStatus)) {
                      <button mat-flat-button color="primary" class="dqf-action-btn" [attr.data-testid]="'dqf-update-' + (carrier.carrierCompanyName | lowercase)">
                        Update DQF
                      </button>
                    }
                    @if (isWithdrawn(carrier.dqfStatus)) {
                      <button mat-stroked-button class="dqf-action-btn withdrawn" disabled [attr.data-testid]="'dqf-withdrawn-' + (carrier.carrierCompanyName | lowercase)">
                        <mat-icon>cancel</mat-icon>
                        Withdrawn
                      </button>
                    }
                  </div>
                </div>
                <div class="dqf-description">
                  <!-- Carrier Logo -->
                  <div class="carrier-logo">
                    <img 
                      [src]="carrier.carrierCompanyLogo || 'assets/images/company-placeholder.png'" 
                      [alt]="carrier.carrierCompanyName + ' logo'"
                      class="carrier-logo-img">
                  </div>
                  <div class="dqf-description-text">
                    <span class="carrier-name" [attr.data-testid]="'dqf-carrier-name-' + (carrier.carrierCompanyName | lowercase)">{{ carrier.carrierCompanyName | uppercase }}</span>
                    @if (isRejected(carrier.dqfStatus)) {
                      <span> has <strong>rejected</strong> your DQF and requested updates</span>
                    }
                    @if (isWithdrawn(carrier.dqfStatus)) {
                      <span> has withdrawn the DQF</span>
                    }
                  </div>
                </div>
              }
            }
            
            <!-- For Non-Hired Drivers without DQF (Pending Onboarding) -->
            @if (!isHired(carrier.hiredStatus) && !carrier.hasDqf) {
              <div class="dqf-approved-hired">
                <div class="carrier-logo-large">
                  <img
                    [src]="carrier.carrierCompanyLogo || 'assets/images/company-placeholder.png'"
                    [alt]="carrier.carrierCompanyName + ' logo'"
                    class="carrier-logo-img-large">
                </div>
                <div class="carrier-main-row">
                  <div class="carrier-names">
                    <span class="carrier-name-large" [attr.data-testid]="'dqf-carrier-name-' + (carrier.carrierCompanyName | lowercase)">{{ carrier.carrierCompanyName | uppercase }}</span>
                    @if (shouldShowDbaName(carrier)) {
                      <span class="carrier-dba-name">{{ carrier.carrierDbaName }}</span>
                    }
                  </div>
                  <div class="status-badge pending-onboarding" [attr.data-testid]="'dqf-status-' + (carrier.carrierCompanyName | lowercase)">
                    <span class="status-text">Pending</span>
                  </div>
                </div>
              </div>
            }

          </div>

          <!-- Company Contacts Icon & Expanded Panel -->
          @if (carrier.driverVisibleContacts && carrier.driverVisibleContacts.length > 0) {
            <div class="card-contacts-section" (click)="$event.stopPropagation()">
              <button
                type="button"
                class="contacts-icon-btn"
                (click)="toggleCardContactsExpanded($event, carrier)"
                [attr.aria-expanded]="carrier.contactsExpanded"
                [attr.data-testid]="'dqf-contacts-' + (carrier.carrierCompanyName | lowercase)"
                aria-label="Company contacts, tap to expand or collapse">
                <mat-icon svgIcon="personnel-icon" class="contacts-trigger-icon"></mat-icon>
              </button>

              @if (carrier.contactsExpanded) {
                <div class="card-contacts-body">
                  @for (contact of carrier.driverVisibleContacts; track $index) {
                    <article class="card-contact-card">
                      <h3 class="card-contact-card-title">{{ contactTypeLabel(contact.type) }}</h3>
                      <div class="card-contact-card-details">
                        @if (contact.phoneNumber) {
                          <div class="card-contact-line">
                            <mat-icon svgIcon="phonecall" class="card-contact-icon" aria-hidden="true"></mat-icon>
                            <div class="card-contact-text">
                              <span class="card-contact-label">Phone Number</span>
                              <a class="card-contact-value" [href]="'tel:' + contact.phoneNumber">{{ contact.phoneNumber }}</a>
                            </div>
                          </div>
                        }
                        @if (contact.whatsApp) {
                          <div class="card-contact-line">
                            <mat-icon svgIcon="customer-whatsapp" class="card-contact-icon" aria-hidden="true"></mat-icon>
                            <div class="card-contact-text">
                              <span class="card-contact-label">WhatsApp</span>
                              @if (whatsappHref(contact.whatsApp)) {
                                <a class="card-contact-value" [href]="whatsappHref(contact.whatsApp)" target="_blank" rel="noopener noreferrer">{{ contact.whatsApp }}</a>
                              } @else {
                                <span class="card-contact-value card-contact-value--muted">{{ contact.whatsApp }}</span>
                              }
                            </div>
                          </div>
                        }
                        @if (contact.email) {
                          <div class="card-contact-line">
                            <mat-icon svgIcon="email" class="card-contact-icon" aria-hidden="true"></mat-icon>
                            <div class="card-contact-text">
                              <span class="card-contact-label">Email</span>
                              <a class="card-contact-value" [href]="'mailto:' + contact.email">{{ contact.email }}</a>
                            </div>
                          </div>
                        }
                        @if (contact.hoursAvailable) {
                          <div class="card-contact-line">
                            <mat-icon svgIcon="on-duty-icon" class="card-contact-icon" aria-hidden="true"></mat-icon>
                            <div class="card-contact-text">
                              <span class="card-contact-label">Hours Available</span>
                              <span class="card-contact-value card-contact-value--muted">{{ contact.hoursAvailable }}</span>
                            </div>
                          </div>
                        }
                      </div>
                    </article>
                  }
                </div>
              }
            </div>
          }

        </div>
      }
    }

    <div class="profile-progress-card margin-left-sm margin-top-sm" (click)="onNavigateToHelpAndSupport()">
      <div class="icon-div">
        <mat-icon class="mat-icon" svgIcon="customer-support"></mat-icon>
      </div>
      <div class="profile-content">
        <div class="title">FleetOperate Support</div>
        <div class="subtitle">Need help? Contact us.</div>
      </div>
    </div>
  </div>
}
<br><br>
</div>
